export class FilterField {
    field;
    value;
    _setValue;

    constructor(field, value) {
        this.field = field;
        [this.value, this._setValue] = value;
    }

    setValue(value) {
        this.value = value;
        this._setValue(value);
    }
}

export class FiltersBundle {
    filtersDict = new Map();
    _setFilters;

    constructor(fields, filterFields, setFilters) {
        this._setFilters = setFilters;
        for (const [field, value] of Object.entries(fields)){
            this.filtersDict.set(field, new FilterField(field, value));
        }
        const params =  filterFields.length >0 ? JSON.parse(filterFields) : [];
        for (const {field, value} of params){
            const role = this.filtersDict.get(field);
            role.value = value;
        }
    }

    applyFilter() {
        this._setFilters(JSON.stringify([...this.filtersDict.values()]
            .filter(p => !!p.value && p.value.trim().length >= 3)
            .map(p => ({ field: p.field, value: p.value }))));
    }

    getFilter(field){
        return this.filtersDict.get(field);
    }

    setFilter(field, value) {
        const rule = this.filtersDict.get(field);
        if(rule.value === value) return;
        rule.setValue(value);
        this.applyFilter();
    }
}